import React, { useEffect, useMemo } from "react";
import { Fragment } from "react";
import {
    Button, Container, Row, Col, Offcanvas,
    OffcanvasHeader, OffcanvasBody, Input, InputGroup, InputGroupText
} from "reactstrap";
import Breadcrumb from "../../components/Common/Breadcrumb";
import TableContainer from "./TableContainerAdmin";
import { GetCookieToken } from "../Cookie/GetCookie";
import axios from "axios";
import { useState } from "react";
import LoadingPage from "../TESTPage/LoadingPage";
import FadeIn from "react-fade-in/lib/FadeIn";
import EditNews from "./EditNews";
import AddTex from "./AddTex";
import styles from "../../assets/css/OPDCNews.module.css";
import { toThaiDate } from "../../helpers/date_helper";
import dayjs from "dayjs";

const API_URL = process.env.REACT_APP_API_CORS;

function OPDCNews() {
    const token = GetCookieToken("userToken");

    const [fileData, setFileData] = useState([]);
    const [info, setInfo] = useState([]);
    const [loading, setLoading] = useState(true);
    const [checkboxDel, setCheckboxDel] = useState(false);
    const [keyword, setKeyword] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState('');

    const fetchFileData = async () => {

        const url = `${API_URL}/api/opdcNews/datatable`;
        const params = new URLSearchParams({
            page: currentPage,
            size: 20,
            "order[0]": "opdc_news_id",
            "order[1]": "DESC",
            search: search,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params,
        };

        await axios.get(url, config).then(async response => {
            setFileData(response.data.result);
            setInfo(response.data.info)
        }).catch(error => console.error("Error:", error));

    };

    const changePageDataTable = async (page) => {
        setCurrentPage(page)
    }

    const refreshDataTable = async () => {
        setLoading(true);
        await fetchFileData();
        setLoading(false);
    }

    const toggleRightCanvas = () => {
        setOpen(!open);
    };

    useEffect(() => {
        const thisEffect = async () => {
            await refreshDataTable();
        }
        thisEffect();
    }, [currentPage, search]);

    const columns = useMemo(
        () => [
            {
                Header: "ลำดับ",
                accessor: "number",
            },
            {
                Header: "หัวข้อข่าว",
                accessor: "heading",
            },
            {
                Header: "วันที่อัปเดต",
                accessor: "updated_date",
            },
            {
                Header: "รูปภาพ",
                accessor: "photo",
            },
            {
                Header: "",
                accessor: "option",
            }
        ],
        []
    );

    const data = fileData
        .map((i, index) => ({
            number: index + 1,
            heading: i?.heading,
            photo: `${i?.photo.length} ภาพ`,
            updated_date: toThaiDate(i?.updated_date),
            option: <EditNews id={i?.opdc_news_id} refreshDataTable={refreshDataTable} />
        }))
        .reverse();

    const refreshDisplay = value => {
        if (value === "รีเฟรชหน้าจอ") {
            setLoading(true);
            setTimeout(() => {
                fetchFileData();
                setLoading(false);
            }, 1500);
        }
    };

    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
      });
    
      useEffect(() => {
        const handleResize = () => {
          setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        };
    
        window.addEventListener('resize', handleResize);
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);

      const handleSearch = () => {
        setSearch(keyword)
      }

      const handleKeyDown = (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          handleSearch();
        }
      };

    return (
        <Fragment>
            <FadeIn>
                {loading ? 
                    <LoadingPage />
                :
                    <div className="page-content">
                        <Container fluid>
                            <Breadcrumb title="หน้าหลัก" breadcrumbItem={`ข่าวสาร`} />
                            <div className="d-xl-flex">
                                <div className="w-100">
                                    <div className="d-md-flex">
                                        <div className="w-100 mb-3 card p-3 shadow">
                                            <Row className="mb-2">
                                                <Col className="d-flex justify-content-between p-1 px-3">
                                                    <div>
                                                        <InputGroup>
                                                            <Input
                                                                style={{ width: windowSize.width < 576 ? '' :'350px' }}
                                                                placeholder={`ค้นหา...`}
                                                                defaultValue={search}
                                                                onChange={e => { setKeyword(e.target.value) }}
                                                                onKeyDown={handleKeyDown}
                                                            />
                                                            <InputGroupText style={{ cursor: "pointer" }}>
                                                                <i className="fa-regular fa-magnifying-glass" onClick={() => handleSearch()}></i>
                                                            </InputGroupText>
                                                        </InputGroup>
                                                    </div>
                                                    <div></div>
                                                    <div>
                                                        <Button color="primary" onClick={toggleRightCanvas} style={{whiteSpace:"nowrap"}}>
                                                            <i class="fa-solid fa-plus"></i> เพิ่มข่าวใหม่
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                            {/* {loading ? (
                                                <LoadingPage />
                                            ) : ( */}
                                                <TableContainer
                                                    refresh={refreshDisplay}
                                                    columns={columns}
                                                    data={data}
                                                    isGlobalFilter={true}
                                                    isAddOptions={false}
                                                    customPageSize={20}
                                                    className=""
                                                    currentPage={info.currentPage}
                                                    totalPage={info.totalPage}
                                                    changePage={changePageDataTable}
                                                />
                                            {/* )} */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Container>
                    </div>
                }
            </FadeIn>
            <Offcanvas
                style={{ border: "none", width: '1000px' }}
                autoFocus
                direction="end"
                isOpen={open}
                toggle={toggleRightCanvas}
                fade
                className="fade custom-w-50"
            >
                <OffcanvasHeader className="position-relative" style={{ background: "#2a3042", color: "#ffffff" }}>
                    <i className="fa-regular fa-newspaper pe-2" style={{ color: "#ffffff" }}></i>
                    บันทึกข่าว
                    <div className={"position-absolute top-0 end-0"}>
                        <i className={`fa-sharp fa-solid fa-circle-xmark pt-3 pe-3 h4 ${styles.pointer}`} onClick={toggleRightCanvas}></i>
                    </div>
                </OffcanvasHeader>
                <OffcanvasBody>
                    <AddTex refreshDataTable={refreshDataTable} setOpen={setOpen} />
                </OffcanvasBody>
            </Offcanvas>
        </Fragment>
    );
}

export default OPDCNews;
